import { render, staticRenderFns } from "./QrCodeImg.vue?vue&type=template&id=14468032"
import script from "./QrCodeImg.vue?vue&type=script&lang=ts"
export * from "./QrCodeImg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports